import styled from 'styled-components'

export const Section = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  border: 0.91px solid #e2e2e2;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  h2 {
    font-size: 1.6rem !important;
    font-weight: 700;
    color: #393939;
    margin: 0;
  }

  svg {
    width: 18px;
    height: 18px;
    color: #f24d33;
    flex-shrink: 0;
  }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-top: 20px;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`

export const Item = styled.div`
  border-top: 3px solid #f24d33;
  padding-top: 12px;

  p {
    font-size: 1.4rem !important;
    font-weight: 400;
    color: #4d4d4d;
    margin: 8px 0 0;

    strong {
      font-weight: 700;
    }
  }
`

export const ItemHeader = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;

  .item-number {
    font-size: 1.4rem !important;
    font-weight: 700;
    color: #f24d33;
  }

  h3 {
    font-size: 1.4rem !important;
    font-weight: 700;
    color: #393939;
    margin: 0;
  }
`

export const EmptyState = styled.div`
  padding: 24px 0;
  text-align: center;
  font-size: 1.4rem !important;
  color: ${({ theme }) => theme.colors.gray80};
`
